/** Criminal Division file category from CMS master data */
export const CRIMINAL_CATEGORY_ID = '9b69b6cd-0166-495b-822e-05f68738782e';
export const CRIMINAL_CATEGORY_CODE = 'CRIMINAL';

export function isBriberySubCategory(name: string): boolean {
  return name.toLowerCase().includes('bribery');
}

export function isOtherLookup(name: string, codeOrId?: string): boolean {
  const code = codeOrId?.toUpperCase();
  if (code === 'OTHER') return true;
  return name.toLowerCase().trim() === 'other';
}
